module.exports = {"340721100":"五松镇","340721101":"顺安镇","340721102":"钟鸣镇","340721103":"天门镇","340721200":"老洲乡","340721201":"东联乡","340721202":"西联乡","340721203":"胥坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340721.json
// module id = 1088
// module chunks = 0